const cities = [
  { name: "Pembroke Pines", zips: "33023, 33024, 33025, 33026, 33027, 33028, 33029, 33082, 33084" },
  { name: "Miramar", zips: "33023, 33025, 33027" },
  { name: "Hollywood", zips: "33019, 33020, 33021, 33022, 33023, 33024, 33026, 33029, 33081, 33083" },
  { name: "Weston", zips: "33326, 33327, 33331, 33332" },
  { name: "Cooper City", zips: "33328, 33330" },
  { name: "Davie", zips: "33314, 33317, 33324, 33328, 33330, 33331" },
  { name: "Southwest Ranches", zips: "33330, 33331, 33332" },
  { name: "Plantation", zips: "33313, 33317, 33322, 33323, 33324, 33325" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function PembrokePinesLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Pembroke Pines &amp; Southwestern Broward County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in central Pembroke Pines, Miramar, Hollywood, Weston, or anywhere in southwestern Broward County, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Pembroke Pines is one of Broward County&apos;s largest and most diverse cities — a sprawling suburban community of roughly 170,000 residents that has grown from a quiet bedroom community into a self-sustaining city with its own identity, amenities, and travel patterns. Incorporated in 1960 as the "Village of Pembroke Pines," the city has transformed from citrus groves and dairy farms into a master-planned suburban hub that stretches across southwestern Broward County, bordered by Miramar to the south, Cooper City to the east, Weston to the north, and the Everglades to the west.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The city&apos;s development accelerated through the 1980s and 1990s as families seeking affordable homes within commuting distance of both Miami and Fort Lauderdale discovered Pembroke Pines&apos; tree-lined neighborhoods, strong schools, and family-friendly atmosphere. Today, the city is home to some of the highest-rated public and charter schools in Florida, including the Pembroke Pines Charter Schools system and Charles W. Flanagan High School, drawing families from across South Florida who prioritize education alongside suburban quality of life.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Pembroke Pines&apos; demographic makeup is notably diverse — one of the most multicultural communities in Broward County. The city has significant Colombian, Venezuelan, Cuban, Dominican, and broader Caribbean populations alongside a well-established Jewish community and growing Brazilian and Central American segments. This diversity shapes the city&apos;s travel DNA in distinctive ways: family visits to Colombia and Venezuela, bar and bat mitzvah trips to Israel, Caribbean heritage travel, and Latin American business connections all create consistent passport demand throughout the year.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            C.B. Smith Park is the crown jewel of Pembroke Pines&apos; recreational offerings — a 299-acre regional park featuring Paradise Cove water park, a championship golf course, fishing lakes, batting cages, tennis courts, and a campground that draws visitors from across South Florida. Pembroke Lakes Mall anchors the city&apos;s retail corridor along Pines Boulevard, serving as both a shopping destination and community gathering point. The city also sits within easy reach of Hard Rock Stadium in Miami Gardens for Dolphins games and major concerts, and the Calder Casino for entertainment.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Pembroke Pines residents enjoy perhaps the most flexible airport access in all of South Florida. Fort Lauderdale-Hollywood International Airport (FLL) is roughly 20–25 minutes east via I-595 or Pines Boulevard, serving as the primary departure point for most residents. Miami International Airport (MIA) is approximately 30–35 minutes south via the Florida Turnpike or I-75, offering expanded international service to Latin America, Europe, and Asia. For northern destinations or when FLL and MIA are congested, Palm Beach International Airport (PBI) is roughly 45–50 minutes north via I-95. This triple-airport flexibility is a genuine competitive advantage for Pembroke Pines travelers.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Port Everglades in Fort Lauderdale, one of the world&apos;s busiest cruise ports, is approximately 25–30 minutes from central Pembroke Pines — making Caribbean cruises an extremely accessible and popular travel option for residents. Royal Caribbean, Carnival, Norwegian, Celebrity, and MSC all operate year-round itineraries that draw thousands of Pembroke Pines families and couples each season.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            What unites Pembroke Pines travelers across every demographic is the same reality: this is a city where international travel is woven into family life, professional obligations, religious traditions, and cultural heritage. When a passport expires or gets damaged days before a planned departure, standard processing is not an option. Fast Passport Center has processed expedited passports for Pembroke Pines travelers from every neighborhood and background — from parents preparing their children for summer trips to Colombia, to business professionals flying to Mexico City, to families embarking on Caribbean cruises from Port Everglades. Our courier-based expedited service means you start online from your Pembroke Pines home — and your passport arrives within days, not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Pembroke Pines — approximately 35–40 miles northeast via I-95 or Florida Turnpike
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Broward County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in southwestern Broward County — start online, ship overnight, and we handle the rest. No need to drive to Miami or Fort Lauderdale.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Plantation", href: "/cities/plantation" },
                  { name: "Hollywood", href: "/cities/hollywood" },
                  { name: "Coral Springs", href: "/cities/coral-springs" },
                  { name: "Weston", href: "/cities/weston" },
                  { name: "Hollywood", href: "/cities/hollywood" },
                  { name: "Fort Lauderdale", href: "/cities/fort-lauderdale" },
                ].map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}